// TODO: Address SMSDownloadLinkModule issue

import React from "react";
import { Hero, HeroProps } from "../SharedServiceTemplate/Hero";
import { Layout } from "../../shared/components/Layout";
import {
  HowItWorks,
  HowItWorksProps,
} from "../SharedServiceTemplate/HowItWorks";
import {
  TaskTemplateServiceBreadcrumbs,
  TaskTemplateServiceBreadcrumbsProps,
} from "./TaskTemplateService/TaskTemplateServiceBreadcrumbs";
import {
  TaskTemplateServiceTextModule,
  TaskTemplateServiceTextModuleProps,
} from "./TaskTemplateService/TaskTemplateServiceTextModule";
import { TaskTemplateFaqs } from "./TaskTemplateService/TaskTemplateFaqs";
import {
  ReadyToHire,
  ReadyToHireProps,
} from "./TaskTemplateService/ReadyToHire";
import {
  // SMSDownloadLinkModule,
  SMSDownloadLinkModuleProps,
} from "../../tr-web/SMSDownloadLinkModule";
import { HeaderNavProps } from "../../tr-web/HeaderNav.stories";
import Publications from "./TaskTemplateService/Publications";

export interface TaskTemplateServiceProps {
  faqsProps: any; // TODO: Make this type declaration work (very frustrating)
  headerNavProps: HeaderNavProps;
  heroProps: HeroProps;
  howItWorksProps: HowItWorksProps;
  readyToHireProps: ReadyToHireProps;
  smsDownloadLinkModuleProps: SMSDownloadLinkModuleProps;
  taskTemplateServiceBreadcrumbsProps: TaskTemplateServiceBreadcrumbsProps;
  taskTemplateServiceTextModuleProps: TaskTemplateServiceTextModuleProps;
}

export function TaskTemplateService({
  faqsProps,
  headerNavProps,
  heroProps,
  howItWorksProps,
  readyToHireProps,
  // smsDownloadLinkModuleProps,
  taskTemplateServiceBreadcrumbsProps,
  taskTemplateServiceTextModuleProps,
}: TaskTemplateServiceProps) {
  return (
    <Layout headerNavProps={headerNavProps}>
      <Hero
        title={heroProps.title}
        subtitle={heroProps.subtitle}
        heroImageFluid={heroProps.heroImageFluid}
        heroButtonPath={heroProps.heroButtonPath}
      />
      <TaskTemplateServiceBreadcrumbs
        marketingGroupIndexPath={
          taskTemplateServiceBreadcrumbsProps.marketingGroupIndexPath
        }
        marketingGroupTitle={
          taskTemplateServiceBreadcrumbsProps.marketingGroupTitle
        }
        origin={taskTemplateServiceBreadcrumbsProps.origin}
        path={taskTemplateServiceBreadcrumbsProps.path}
        serviceIndexPath={taskTemplateServiceBreadcrumbsProps.serviceIndexPath}
        templateName={taskTemplateServiceBreadcrumbsProps.templateName}
      />
      <TaskTemplateServiceTextModule
        textModuleDescription={
          taskTemplateServiceTextModuleProps.textModuleDescription
        }
        textModuleImage={taskTemplateServiceTextModuleProps.textModuleImage}
        textModuleSectionTitle={
          taskTemplateServiceTextModuleProps.textModuleSectionTitle
        }
      />
      <HowItWorks
        stepOneFixed={howItWorksProps.stepOneFixed}
        stepTwoFixed={howItWorksProps.stepTwoFixed}
        stepThreeFixed={howItWorksProps.stepThreeFixed}
      />
      <ReadyToHire
        callToActionUrl={readyToHireProps.callToActionUrl}
        displayCta={readyToHireProps.displayCta}
        womanCookingWithDaughterFluid={
          readyToHireProps.womanCookingWithDaughterFluid
        }
      />
      <TaskTemplateFaqs faqsProps={faqsProps} />
      {/* Temporarily hide this to prevent SMS issue */}
      {/* <SMSDownloadLinkModule
        womanWorkingOnPhoneFluid={
          smsDownloadLinkModuleProps.womanWorkingOnPhoneFluid
        }
      /> */}
      <Publications />
    </Layout>
  );
}
